<template>
  <ContentsPageTitleV2 capital="SEE HOW OUR PRODUCTS ARE USED IM YOUR APPLICATIONS" title="Use Case" description="ADAS"/>
  <CardUserCase :contents="ADAS"/>

</template>

<script setup>
import CardUserCase from '~/components/contents/CardUserCase.vue'

useHead({
  title: 'adas - NAGASE THAILAND Engineering Plastics',
})



const ADAS = [
  {
    "pdf": true,
    "img": "/pages/products/use-cases/ds01.jpg",
    "title": "SABIC Solutions for advanced Driver Assistance Systems (ADAS)",
    "to": "/wp-content/uploads/2022/08/01.pdf"
  },
  {
    "pdf": true,
    "img": "/pages/products/use-cases/sd01.jpg",
    "title": "SABIC Mobility ADAS Camera Flyer",
    "to": "/wp-content/uploads/2022/08/SABIC-Mobility-ADAS%20Camera%20Flyer%20(4).pdf"
  },
  {
    "pdf": true,
    "img": "/pages/products/use-cases/xc01.jpg",
    "title": "SABIC Mobility ADAS LIDAR Flyer",
    "to": "/wp-content/uploads/2022/08/SABIC-Mobility-ADAS%20LIDAR%20Flyer%20(1).pdf"
  },
  {
    "pdf": true,
    "img": "/pages/products/use-cases/w01.jpg",
    "title": "ADAS Radar Application Sheet NA FNL",
    "to": "/wp-content/uploads/2022/08/ADAS%20Radar%20Application%20Sheet%20NA%20FNL.pdf"
  }

]
</script>
